// 세션 리플레이 SDK 연동 (Carrot 자체 모니터링). OpenReplay 와 병행 가동한다.
// 이 레포는 vue-cli 5(webpack 5)로 업그레이드해 SDK 의 exports 서브패스를 정상 해석한다.
// SDK/rrweb 의 모던 문법은 vue.config.js 의 transpileDependencies 로 babel 트랜스파일한다.
import { ReplayRecorder } from "@carrot/session-replay/core";

// 어드민(replays-admin.carrotsolutions.co.kr)에서 발급받은 X-Replay-Project-Key.
const REPLAY_PROJECT_KEY = "QZZRPL2V";

let recorder = null;

// 앱 부트스트랩 시 1회 호출. localhost 는 SDK 내부에서 자동으로 녹화하지 않는다.
export async function startSessionReplay() {
  if (recorder) return;
  recorder = new ReplayRecorder({ projectKey: REPLAY_PROJECT_KEY });
  await recorder.start();
}

// 로그인 성공 시 호출. 기존 tracker.setUserID(...) 옆에 나란히 둔다.
export function setReplayUserId(userId) {
  recorder?.setUserId(userId);
}
